import { Action } from "@ngrx/store";
import { IAppBooted } from "src/app/models/boot";

export enum EBootActions {
  BootAttempt = "[Boot] Attempt",
  BootAttemptSuccess = "[Boot] Attempt Success",
  BootAttemptFailed = "[Boot] Attempt Failed",
}

export enum ESetttingsActions {
  SettingsRequest = "[Settings] Request",
  SettingsRequestOk = "[Settings] Request Ok",
  SettingsRequestFailed = "[Settings] Request Failed",
}

export class BootAttempt implements Action {
  public readonly type = EBootActions.BootAttempt;
  constructor(public payload: any) {}
}

export class BootAttemptSuccess implements Action {
  public readonly type = EBootActions.BootAttemptSuccess;
  constructor(public payload: IAppBooted) {}
}

export class BootAttemptFailed implements Action {
  public readonly type = EBootActions.BootAttemptFailed;
  constructor(public payload: IAppBooted) {}
}

/** Settings */
export class appSettingsRequest implements Action {
  public readonly type = ESetttingsActions.SettingsRequest;
  constructor(public payload: any) {}
}

export class appSettingsRequestOk implements Action {
  public readonly type = ESetttingsActions.SettingsRequestOk;
  constructor(public payload: any) {}
}

export class appSettingsRequestFailed implements Action {
  public readonly type = ESetttingsActions.SettingsRequestFailed;
  constructor(public payload: any) {}
}

export type SettingsActions =
  | appSettingsRequest
  | appSettingsRequestOk
  | appSettingsRequestFailed;
export type BootActions = BootAttempt | BootAttemptSuccess | BootAttemptFailed;
